module.exports = __webpack_public_path__ + "static/media/Person13.1ed67c5f.png";